import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router/index'
import store from './store'
import Xhr from './assets/js/common/api'
import './assets/css/index.scss'

console.log('store:', store)
const commit = store.commit
router.beforeEach((to, from, next) => {
  console.log('to:', to)
  if (to.fullPath === '/sharingcenter') {
    commit('SET_NAV', 'product')
  } else if (to.fullPath === '/resourcedownloading') {
    commit('SET_NAV', 'resource')
  } else if (to.fullPath === '/personalcenter') {
    commit('SET_NAV', 'prsonal')
  }
  setTimeout(next, 0)
})
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.$xhr = Xhr
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
